import type { UnifiedSignupScreenName } from '../UnifiedSignupScreenName';
import AbstractCheckErrorSignupScreen from './AbstractCheckErrorSignupScreen';

export default class EmailCheck422SignupScreen extends AbstractCheckErrorSignupScreen {
  public screenName: UnifiedSignupScreenName = 'uss-email-check-422';

  public predicate(): boolean {
    const { emailCheckCode } = this.sessionInfo.value;
    if (emailCheckCode !== 422) {
      return false;
    }
    return true;
  }
}
